/*@ngInject*/
const LandingMediator = function ($q, coreMediator, loadActivityRepository, loadTaskRepository, loadWidgetLayoutTemplateRepository) {


    this.loadRecentActivityList = function (activityParams) {
        return loadActivityRepository.loadActivityStreamItems(activityParams);
    };

    this.loadTasks = function (taskParams) {
        return loadTaskRepository.loadTasks(taskParams);
    };
    this.getTaskDownloadUrl = function(taskParams) {
        return loadTaskRepository.getDownloadUrl(taskParams);
    };

    this.loadWidgetLayoutTemplate = function () {
        return loadWidgetLayoutTemplateRepository.loadWidgetLayoutTemplate();
    };
};

angular.module('umLanding').service('landingMediator', LandingMediator);
